var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"data-refresh-menu grid-menu-item",class:{'is-refresh': _vm.refreshing},attrs:{"type":"text"},on:{"click":_vm.handleClick}},[(_vm.refreshing)?_c('i',{staticClass:"theme-text iconfont icon-shuaxin"}):_c('i',{staticClass:"iconfont icon-shuaxin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }